export enum FileSize {
  KILOBYTES = 1024,
  MEGABYTES = Math.pow(FileSize.KILOBYTES, 2),
  GIGABYTES = Math.pow(FileSize.KILOBYTES, 3),
}
